import { render, staticRenderFns } from "./modularChild2.vue?vue&type=template&id=4794ad53&scoped=true"
import script from "./modularChild2.vue?vue&type=script&lang=js"
export * from "./modularChild2.vue?vue&type=script&lang=js"
import style0 from "./modularChild2.vue?vue&type=style&index=0&id=4794ad53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4794ad53",
  null
  
)

export default component.exports